export const experienceData = [
    {
        id: 1,
        company: 'Google',
        jobtitle: 'Software Engineer',
        startYear: '2024',
        endYear: '2025',
        startMonth: 'Aug',
        endMonth: 'Feb',
    },
    {
        id: 2,
        company: 'Google',
        jobtitle: 'Software Engineering Intern',
        startYear: '2024',
        endYear: '2024',
        startMonth: 'Feb',
        endMonth: 'July',
    },
    {
        id: 2,
        company: 'Oracle',
        jobtitle: 'Project Intern',
        startYear: '2023',
        endYear: '2023',
        startMonth: 'May',
        endMonth: 'July'
    },
]